var r = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e.Large = "large", e))(r || {}), l = /* @__PURE__ */ ((e) => (e.Default = "default", e.Success = "success", e.Danger = "danger", e))(l || {});
export {
  r as SizesEnum,
  l as VariantsEnum
};
